// modules
import React from 'react';

// local
import './Footer.css';


const Footer = () =>  (
  <div className={ 'Footer__wrapper' }>
    <div className={ 'Footer__container' }>
      <img className={ 'Footer__logo' } src={ '/_img/footer-logo.svg' } alt={ 'logo' } />
    </div>
    <h3 className={ 'Footer__text' }>{ '© 2019 Momentum Tech. All Right Reservesd' }</h3>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js